<template>
	<div class="card">
        <div class="card-body">
            <div v-bind:class="loading">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border m-5" role="status">
                    <span class="sr-only">{{ $t("page.general.cargar") }}</span>
                  </div>
                </div>
            </div>
            <div v-bind:class="result">
                <div class="row">
                    <div class="col-12" v-if="!setTitle">
                        <h5>{{ $t("page.constancia.mis_costancias") }}</h5>
                    </div>
                    <div class="b-table-sticky-header table-responsive" style="max-height: 300px;">
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <th scope="col">{{ $t("page.constancia.nombre_curso") }}</th>
                              <th scope="col">{{ $t("page.constancia.tipo_documento") }}</th>
                              <th scope="col">{{ $t("page.constancia.documento") }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colspan="3" class="text-center" v-if="items.length==0 && bloquesTerminados.length == 0">
                                <h6 class="mr-4">{{ $t("page.constancia.sin_constancia") }}</h6>
                              </td>
                            </tr>
                            <tr v-for="tema,index of items" :key="index+'tema'">
                              <th scope="row">{{tema.nombre}}</th>
                              <td>Capacitación</td>
                              <td>
                                <button v-if="tema.cve_sap_modalidad!=2" v-on:click="Descargar_DC3(tema)" class="btn btn-sm btn-success">
                                    <i class="fas fa-cloud-download-alt"></i> DC3
                                </button>
                                <button v-on:click="Descargar_Constancia(tema)" class="btn btn-sm btn_blue">
                                    <i class="fas fa-cloud-download-alt"></i>  {{ $t("page.constancia.constancia") }}
                                </button>
                              </td>
                            </tr>
                            <div v-if="cia.enable_bloques_cursos === '1'">
                              <tr v-for="bloque,index of bloquesTerminados" :key="index+'bloque'">
                                <th scope="row">{{bloque.nombre_bloque}}</th>
                                <td>{{bloque.tipo_bloque}}</td>
                                <td>
                                  <button v-on:click="descargarConstanciaBloque(bloque)" class="btn btn-sm btn_blue">
                                    <i class="fas fa-cloud-download-alt"></i>  {{ $t("page.constancia.constancia") }}
                                  </button>
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
  abrirConstanciaCursoPdf,
  abrirConstanciaBloquePdf
} from "@/utils/constanciaDownload.js";

export default {
  props:['setTitle', 'bloques'],
  data () {
    return {
      loading:'',
      result:'d-none',
      requerimiento:{
        nombre2:'',
        temas:[]
      },
      items: [],
      bloquesTerminados: [],
    }
  },
  methods:{
    Descargar_Constancia(requerimiento) {
      this.requerimiento = requerimiento;
      abrirConstanciaCursoPdf(
        this.$http,
        this.usuario.cve_empleado,
        requerimiento.cve_curso
      ).catch(() => {
        swal("Error", "No se pudo generar la constancia.", "error");
      });
    },
    descargarConstanciaBloque(bloque) {
      abrirConstanciaBloquePdf(
        this.$http,
        this.usuario.cve_empleado,
        bloque.id_bloque
      ).catch(() => {
        swal("Error", "No se pudo generar la constancia del bloque.", "error");
      });
    },
    Descargar_DC3(requerimiento) {
      this.$http
        .get(`cursos/actions/ver_participantes/descargar/dc3/${requerimiento.cve_empleado}/${requerimiento.cve_curso}`,
          {}
        )
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          var mapForm = document.createElement("form");
          mapForm.target = "_blank";
          mapForm.method = "POST";
          mapForm.id = "POST_dc3";
          mapForm.action =this.$http.options.url+'/../../../static/files/dc3/index.php';
          var mapInput = document.createElement("input");
          mapInput.type = "text";
          mapInput.name = "cve_curso";
          mapInput.id = "cve_curso";
          mapInput.value = requerimiento.cve_curso;
          var mapInput2 = document.createElement("input");
          mapInput2.type = "text";
          mapInput2.name = "cve_empleado";
          mapInput2.id = "cve_empleado";
          mapInput2.value = requerimiento.cve_empleado;
          var mapInput3 = document.createElement("textarea");
          //mapInput3.type = "text";
          mapInput3.name = "token";
          mapInput3.id = "token";
          mapInput3.value = JSON.parse(localStorage.apiKey_lms);
          var mapInput4 = document.createElement("button");
          mapInput4.type = "submit";
          mapInput4.name = "save";
          mapInput4.id = "save";
          mapInput4.value = "Consultar";
          mapForm.appendChild(mapInput);
          mapForm.appendChild(mapInput2);
          mapForm.appendChild(mapInput3);
          mapForm.appendChild(mapInput4);
          document.body.appendChild(mapForm);
          $(document).ready(function(){
            mapForm.submit();
            setTimeout(function(){
              document.body.removeChild(mapForm);
            },1000);
          });
        })
        .catch(error => {
          if (error.body === 'No se encontro información del curso') {
            swal(
              error.body,
              '',
              'error'
            );
          } else {
            let mensajes = error.body.split('<br>');

            // 2. Filtrar elementos vacíos
            mensajes = mensajes.filter(mensaje => mensaje.trim() !== '');

            // 3. Obtener solo las partes después de los dos puntos
            let valores = mensajes.map((mensaje, index) => {
              let partes = mensaje.split(':');
              return `${index + 1} - ${partes[1].trim().toUpperCase()}`; // Eliminar espacios en blanco adicionales
            });
            swal(
              `El curso tiene datos incompletos`,
              valores.join('\n'),
              'error'
            );
          }
        });
    },
    Consultar() {
      console.log('DEBUG: Consultar', );
      this.Cargando();
      this.$http.get('dashboard/getCursosAcreditados')
      .then(respuesta => { return respuesta.json() })
      .then(respuestaJson => {
        this.Listo();
        console.log('DEBUG: constancias', respuestaJson);
        if (respuestaJson.length > 0) {
          // this.requerimiento.nombre2=respuestaJson[0].nombre2;
          // for (var i = 0; i < respuestaJson[0].temas.length; i++) {
          //   this.requerimiento.temas.push(respuestaJson[0].temas[i]);
          //   // this.items.push(respuestaJson[0].temas[i]);
          // }

          // const todosLosTemas = respuestaJson.flatMap(matriz => matriz.temas);
          this.items = respuestaJson;

        }else{
          this.requerimiento = {
            nombre2: '',
            temas: []
          };
          this.items = [];
        }
        })
        .catch(error=>{
          this.loading='d-none';
        });
    },
    Cargando(){
      this.result="d-none";
      this.loading="";
    },
    Listo(){
      this.result="";
      this.loading="d-none";
    }
  },
  created() {
  },
  mounted(){
    this.Consultar();
    setTimeout(() => {
      console.log('DEBUG: this.bloques', this.bloques);
      this.bloquesTerminados = this.bloques.filter(bloque => {
        return bloque.estatus === '1';
      });

      console.log('DEBUG: this.bloquesTerminados', this.bloquesTerminados);
    }, 500);
  },
  computed:{
    cia() {
      return this.$store.getters.getCia;
    },
    menu(){
      return this.$store.getters.getMenu;
    },
    usuario(){
      return this.$store.getters.getUsuario;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/MisConstancias/MisConstancias.vue